<template>
    <div>
        <div class="box view-nav-bar">
            <div class="d-flex align-items-center w-100">
                <div class="flex-grow-1">
                    <router-link to="/admissions/year" class="mr-3">
                        <icon name="chevron-left"/> Back
                    </router-link>
                    <strong>{{ year }}</strong>
                    <span class="text-muted ml-2">— Admissions per week, saleshouse <strong>BF</strong></span>
                </div>
            </div>
        </div>

        <div v-if="loading" class="box">
            <div class="box-content text-center text-muted py-4">Loading…</div>
        </div>

        <div v-else-if="!rows.length" class="box">
            <div class="box-content text-center text-muted py-4">No admissions data found for {{ year }}.</div>
        </div>

        <div v-else class="box">
            <div class="box-content">
                <table class="shx-table w-100 mt-2">
                    <thead>
                        <tr>
                            <th class="shx-th-100">Week</th>
                            <th class="shx-th-120">Start</th>
                            <th class="shx-th-120">End</th>
                            <th class="text-right">Admissions</th>
                            <th class="text-right shx-th-100"># Cinemas</th>
                            <th class="text-right shx-th-100"># Titles</th>
                            <th class="text-right shx-th-100">Real %</th>
                            <th class="shx-th-120"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="row in rows" :key="row.week_code">
                            <td>
                                <router-link :to="'/admissions/year/' + year + '/' + row.week_code">
                                    {{ row.week_code }}
                                </router-link>
                            </td>
                            <td>{{ row.week_start || '—' }}</td>
                            <td>{{ row.week_end || '—' }}</td>
                            <td class="text-right">{{ formatInt(row.admissions) }}</td>
                            <td class="text-right">{{ row.cinemas }}</td>
                            <td class="text-right">{{ row.titles }}</td>
                            <td class="text-right">
                                <span>{{ row.real_weighted !== null ? row.real_weighted + '%' : '—' }}</span>
                                <span v-if="row.real_weighted !== null && row.real_weighted <= 90"
                                      class="badge badge-warning ml-1"
                                      :title="'Minimum real: ' + row.real_min + '%'">⚠</span>
                            </td>
                            <td>
                                <router-link :to="'/admissions/year/' + year + '/' + row.week_code"
                                             class="btn btn-sm btn-outline-secondary">
                                    Per Cinema
                                </router-link>
                            </td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <td colspan="3"><strong>Total</strong></td>
                            <td class="text-right"><strong>{{ formatInt(totalAdmissions) }}</strong></td>
                            <td colspan="4"></td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    name: 'AdmissionsYearWeeks',
    props: ['year'],
    data() {
        return {
            loading: true,
            rows: [],
        };
    },
    computed: {
        totalAdmissions() {
            return this.rows.reduce((sum, r) => sum + (r.admissions || 0), 0);
        },
    },
    created() {
        this.loadWeeks();
    },
    watch: {
        year() {
            this.loadWeeks();
        },
    },
    methods: {
        loadWeeks() {
            this.loading = true;
            axios
                .get(`/admissions/year/${this.year}/weeks`)
                .then(response => {
                    this.rows = response.data.data.rows || [];
                })
                .catch(error => {
                    this.$toast.error(error.response?.data?.error?.message || error.message);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        formatInt(v) {
            return Math.round(v || 0).toLocaleString();
        },
    },
};
</script>
